// src/components/ConsentBanner.js — DR-Aura ULTIMATE
import React, { useState, useEffect } from 'react';

const KEY = 'draura_consent_v2';

const ConsentBanner = () => {
  const [show,   setShow]   = useState(false);
  const [detail, setDetail] = useState(false);
  const [prefs,  setPrefs]  = useState({ analytics: false, marketing: false });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(KEY);
      if (!saved) setTimeout(() => setShow(true), 1800);
    } catch {}
  }, []);

  const save = (accepted) => {
    const consent = {
      essential: true,
      analytics: accepted ? true : prefs.analytics,
      marketing: accepted ? true : prefs.marketing,
      timestamp: new Date().toISOString(),
      version: 2,
    };
    try { localStorage.setItem(KEY, JSON.stringify(consent)); } catch {}
    setShow(false);
    window.dispatchEvent(new CustomEvent('draura:consent', { detail: consent }));
  };

  if (!show) return null;

  return (
    <div role="dialog" aria-modal="true" aria-label="Cookie preferences"
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9998,
        background: 'rgba(16,10,3,0.97)', backdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(201,151,26,0.4)',
        padding: '1.25rem 1.5rem',
        boxShadow: '0 -12px 48px rgba(0,0,0,0.6)',
        animation: 'slideUp 0.3s ease',
      }}>
      <style>{`@keyframes slideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}`}</style>

      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        {!detail ? (
          <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
            <img src="/dr-logo-icon.png" alt="DR-Aura" width={32} height={32}
              style={{ objectFit: 'contain', flexShrink: 0 }}
              onError={e => e.target.style.display = 'none'} />
            <p style={{ flex: 1, fontFamily: "'DM Sans', sans-serif", fontSize: '0.87rem',
              color: 'rgba(248,237,224,0.75)', margin: 0, lineHeight: 1.55 }}>
              We use essential cookies for auth and optional analytics/ads (free tier).{' '}
              <button onClick={() => setDetail(true)}
                style={{ background: 'none', border: 'none', color: '#c9971a', cursor: 'pointer',
                  fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.87rem', padding: 0 }}>
                Customise
              </button>
            </p>
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              <button onClick={() => save(false)}
                style={{ padding: '0.45rem 1rem', borderRadius: 999, border: '1px solid rgba(201,151,26,0.4)',
                  background: 'transparent', color: 'rgba(248,237,224,0.8)', cursor: 'pointer',
                  fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.83rem' }}>
                Reject optional
              </button>
              <button onClick={() => save(true)}
                style={{ padding: '0.45rem 1rem', borderRadius: 999, border: 'none',
                  background: 'linear-gradient(135deg,#7a5c10,#c9971a)', color: '#0a0603',
                  cursor: 'pointer', fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.83rem', fontWeight: 700 }}>
                Accept all
              </button>
            </div>
          </div>
        ) : (
          <div style={{ maxWidth: 560 }}>
            <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '1rem', fontWeight: 700,
              color: 'rgba(248,237,224,0.9)', marginBottom: 12 }}>Cookie Preferences</h3>
            {[
              { id: 'essential', label: 'Essential',   desc: 'Required for login and core functionality.', locked: true  },
              { id: 'analytics', label: 'Analytics',   desc: 'Google Analytics — helps improve DR-Aura (optional).', locked: false },
              { id: 'marketing', label: 'Advertising', desc: 'Google AdSense — free-tier only. Pro users are always ad-free.', locked: false },
            ].map(c => (
              <div key={c.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 0', borderBottom: '1px solid rgba(201,151,26,0.15)' }}>
                <div>
                  <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.87rem', fontWeight: 600,
                    color: 'rgba(248,237,224,0.9)' }}>
                    {c.label} {c.locked && <span style={{ fontSize: '0.68rem', color: 'rgba(122,92,64,0.9)' }}>(always on)</span>}
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.76rem',
                    color: 'rgba(122,92,64,0.9)', marginTop: 2 }}>{c.desc}</div>
                </div>
                {c.locked ? (
                  <span style={{ color: '#c9971a', fontSize: '0.9rem' }}>✓</span>
                ) : (
                  <button onClick={() => setPrefs(p => ({ ...p, [c.id]: !p[c.id] }))}
                    aria-pressed={prefs[c.id]}
                    style={{ width: 42, height: 23, borderRadius: 12, border: 'none', cursor: 'pointer',
                      background: prefs[c.id] ? '#c9971a' : 'rgba(56,35,16,0.9)',
                      position: 'relative', transition: 'background 0.2s', flexShrink: 0 }}>
                    <span style={{ position: 'absolute', top: 2.5, left: prefs[c.id] ? 21 : 2.5,
                      width: 18, height: 18, borderRadius: '50%', background: '#fff',
                      transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' }}/>
                  </button>
                )}
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
              <button onClick={() => setDetail(false)}
                style={{ padding: '0.4rem 0.9rem', borderRadius: 999, border: '1px solid rgba(201,151,26,0.3)',
                  background: 'transparent', color: 'rgba(248,237,224,0.7)', cursor: 'pointer',
                  fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.82rem' }}>
                ← Back
              </button>
              <button onClick={() => save(false)}
                style={{ flex: 1, padding: '0.4rem 0.9rem', borderRadius: 999, border: 'none',
                  background: 'linear-gradient(135deg,#7a5c10,#c9971a)', color: '#0a0603',
                  cursor: 'pointer', fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.82rem', fontWeight: 700 }}>
                Save preferences
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsentBanner;
